import React from 'react';

import { t } from 'i18next';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Button, Modal, ModalBody } from 'reactstrap';

import { deleteNotification } from 'store/actions';

import './DeleteModalNotification.scss';

const DeleteModalNotification = ({
  deleteNotification,
  closeModal,
  getSelectedItem,
  selectedItemId,
  isOpen,
  refreshNotification,
}) => {
  const selectedItem = getSelectedItem(selectedItemId);
  const language = useSelector((state) => state.Layout.language);
  const deleteNotificationHandler = () => {
    deleteNotification({ id: selectedItemId, language });
    closeModal();
    refreshNotification();
  };
  return (
    <Modal isOpen={isOpen} toggle={closeModal} centered>
      <ModalBody className="notifications__modal_delete_body">
        {selectedItem && (
          <div>
            {t('notification_delete_notification')} <br />
            <span>{selectedItem.notification_title}</span>?
          </div>
        )}
        <div className="notifications__modal_delete_btns flex-row">
          <Button color="primary" onClick={closeModal}>
            {t('common_cancel')}
          </Button>
          <Button color="danger" onClick={deleteNotificationHandler}>
            {t('common_delete')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

DeleteModalNotification.propTypes = {
  closeModal: PropTypes.func,
  submitHandler: PropTypes.func,
  isOpen: PropTypes.bool,
  selectedItemId: PropTypes.number,
  deleteNotification: PropTypes.func,
  getSelectedItem: PropTypes.func,
};
const mapStateToProps = (state) => ({
  getSelectedItem: (id) => state.Notifications?.adminNotifications?.items?.find((item) => item.id === id),
});

const mapDispatchToProps = (dispatch) => ({
  deleteNotification: (id) => dispatch(deleteNotification(id)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DeleteModalNotification);
